import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRightChevron = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 1000",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M326 68L760 503L325 937L270 882L652 502L270 123Z" })
});
export default SvgRightChevron;
